export default __webpack_public_path__ + "static/media/artist1.6a566ee4.jpg";